import { useEffect, useState } from "react";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import { ProductCard } from "./ProductCard";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

const ProductContainer = () => {

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  // ✅ FETCH PRODUCTS FROM BACKEND
  useEffect(() => {
    axios.get("https://purvi-backend.onrender.com/products")
      .then(res => {
        console.log("DATA:", res.data); 
        setProducts(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="products-container">

      {/* HEADER */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p style={{ fontWeight: "600", fontSize: "20px" }}>
          My Products
        </p>

        {/* <Button variant="contained">View All</Button> */}
      </div>

      {/* LOADER */}
      {
        loading ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <CircularProgress />
          </div>
        ) : (
          
          <div className="product-grid-layout">
  {products.map((product) => (
    <Link
      key={product._id}
      to={`/product/${product._id}`}
      style={{ textDecoration: "none", color: "black" }}
    >
      <ProductCard {...product} />
    </Link>
  ))}
</div>
        )
      }

    </div>
  );
};

export default ProductContainer;
